import { cn } from "@/lib/utils";
import { statusIT } from "@/lib/format";

const STATUS_STYLES = {
  planned: "bg-sky-50 text-sky-800 border-sky-200",
  partially_paid: "bg-amber-50 text-amber-800 border-amber-200",
  paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
  skipped: "bg-stone-100 text-stone-500 border-stone-200 line-through",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
  not_due: "bg-slate-50 text-slate-600 border-slate-300",
};

/**
 * StatusBadge — usato nella griglia operativa.
 *
 * Iter40: rimosso badge "Modificata" dalla griglia principale (rumore
 * visivo senza valore operativo). L'informazione resta consultabile nel
 * dettaglio della scadenza e nello storico modifiche. Il prop `modified`
 * è mantenuto per retrocompatibilità ma viene ignorato.
 *
 * Per le rate di un piano (custom_plan) preferire il badge `InstallmentBadge`
 * dedicato (Rata X/N) invece dello status generico "In programma".
 */
export const StatusBadge = ({ status, postponed = false, className }) => (
  <span className={cn("inline-flex items-center gap-1.5", className)}>
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wide",
        STATUS_STYLES[status] || STATUS_STYLES.planned,
      )}
    >
      {statusIT[status] || status}
    </span>
    {postponed && (
      <span
        data-testid="badge-postponed"
        title="Scadenza rinviata"
        className="inline-flex items-center whitespace-nowrap rounded-full border border-blue-200 bg-blue-50 px-2 py-0.5 text-[10px] font-medium uppercase text-blue-700"
      >
        Rinviata
      </span>
    )}
  </span>
);

/**
 * InstallmentBadge — sostituisce "IN PROGRAMMA" per le scadenze di un
 * piano rateale (custom_plan). Mostra "Rata X/N" quando il totale è
 * noto, altrimenti "Piano rateale" come fallback.
 */
export const InstallmentBadge = ({ sequence, total, className }) => {
  const label = sequence && total
    ? `Rata ${sequence}/${total}`
    : sequence
      ? `Rata ${sequence}`
      : "Piano rateale";
  return (
    <span
      data-testid="installment-badge"
      title="Scadenza appartenente a un piano rateale"
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full border border-indigo-200 bg-indigo-50 px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-wide text-indigo-800",
        className,
      )}
    >
      {label}
    </span>
  );
};
